exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contact-jsx": () => import("./../../../src/pages/contact.jsx" /* webpackChunkName: "component---src-pages-contact-jsx" */),
  "component---src-pages-despre-jsx": () => import("./../../../src/pages/despre.jsx" /* webpackChunkName: "component---src-pages-despre-jsx" */),
  "component---src-pages-domenii-de-practica-jsx": () => import("./../../../src/pages/domenii-de-practica.jsx" /* webpackChunkName: "component---src-pages-domenii-de-practica-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

